import React from 'react'
import './index.scss'

// import Button from '../../Components/Button'

export default function Agreement() {
  const title = '腾讯音乐开放平台服务协议'
  const signature = ''
  const sections = [
    {
      paragraphs: [
        '欢迎你使用腾讯音乐开放平台（以下简称“平台”）及服务！',
        '为更好地方便你使用平台及相关服务，你应当阅读并遵守《腾讯音乐开放平台服务协议》（以下简称“本协议”）和《腾讯服务协议》、《QQ号码规则》、《腾讯微信软件许可及服务协议》和《隐私政策》等相关协议和业务规则。<b style="font-weight:bold">请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。限制、免责条款可能以加粗等形式提示你注意。</b>',
        '<b style="font-weight:bold">除非你已阅读并接受本协议所有条款，否则你无权注册成为平台用户及享受相关服务。你的注册、登录、分享/传播相关内容等任何使用平台服务的相关行为即视为你已阅读并同意本协议的约束。</b>',
        '如果你未满18周岁，请在法定监护人的陪同下或经过法定监护人同意后，再进行阅读、接受本协议以及完成相关内容的分享/传播等操作，否则，请你不要接受本协议以及进行相关操作；若你进行了接受本协议、分享/传播相关内容等操作，将视为你的任何操作均是在法定监护人的陪同下或经过法定监护人同意后进行的，会对你及你的法定监护人产生法律约束力。'
      ]
    },
    {
      title: '一、名词定义',
      paragraphs: [
        '<b style="font-weight:bold">1.1 腾讯音乐开放平台</b>',
        '指为方便你分享、传播你有权的词或曲音乐作品、录音录像制品、MV作品、文字作品、图片作品、视频作品及其他相关内容，为你提供信息存储空间及相关技术支持等服务的平台，以下简称“平台”。'
      ]
    },
    {
      paragraphs: [
        '<b style="font-weight:bold">1.2 分享内容</b>',
        '指你上传到平台的你拥有相应的全部权利的各种形式的词或曲音乐作品、录音录像制品、MV作品、文字作品、图片作品、视频作品以及其他相关的全部内容（包括词曲作者或表演者照片、个人简介、文字内容、图片、视听作品、专辑封面、专辑制作花絮、音乐文档、宣传短片等），具体分享内容形式包括代词或不带词音频形式、视频形式、MV形式（类电影作品）、文字形式、图片形式等各种形式，具体以你上传提供的为准。',
      ]
    },
    {
      paragraphs: [
        '<b style="font-weight:bold">1.3 开放平台用户</b>',
        '指将自己有权的分享内容上传到平台上以进行分享、传播的企业、法人、其他组织或个人，具体可能包括原创或独立音乐人、经纪公司或经纪人、唱片公司或代理公司、乐评人等类型的用户，以下简称“平台用户”或“你”，同时：',
        '（1）你理解和同意：腾讯（包括腾讯音乐娱乐集团及其关联公司，本协议中均指本含义）是一个中立的平台服务提供者，在平台相关服务中，仅向你提供信息存储空间等中立的网络服务或技术支持服务。关联公司：指控制本协议一方，或被本协议一方所控制，或与本协议一方共同受控制于同一实体的任何企业。控制是指直接或间接拥有该企业百分之五十（50％）以上的股权、投票权或管理权，或通过协议控制该企业管理权（下同）。',
        '（2）你保证：对于你上传到平台的分享内容，你是与分享内容相关的全部权利的原始权利人或经过相关原始权利人的合法授权（此情况下，你确保授权给你相关权利的权利人知悉并同意你按照本协议以及平台相关协议、规则，将分享内容按照本平台规则进行分享和传播。比如，若你是代表乐队注册上传分享内容时，你应自行取得全部乐队成员以及分享内容所涉相关全部原始权利人的授权；若你是经纪公司或唱片公司等单位主体，你应自行获得分享内容所涉相关全部原始权利人的授权），否则，你不会将分享内容上传到平台。',
        '（3）你保证：<b style="font-weight:bold">你将分享内容上传到平台的行为，即视为你已经确保你拥有与分享内容相关的全部权利，腾讯按照与你约定的方式使用分享内容，不会侵犯任何他人的合法权益，否则，若因为你上传的分享内容的著作权、邻接权、以及其他知识产权、肖像权、名誉权权利等任何问题侵害到他人权益的，你须自行承担全部责任。</b>',
        '（4）你保证：若你对分享内容享有的全部权利的权利状况发生变化时，你会第一时间通过书面形式通知腾讯，腾讯收到通知后，会根据你的书面通知内容，决定是否继续使用你的分享内容。'
      ]
    },
    {
      paragraphs: [
        '<b style="font-weight:bold">1.4 分享内容的全部权利</b>',
        '<b style="font-weight:bold">指与分享内容相关的全部权利，具体包括但不限于如下权利等（以下简称“全部权利”）：</b>',
        '<b style="font-weight:bold">（1）与分享内容相关的词著作权、曲著作权、表演者权利、录音制作者权、录音录像制作者权等相关著作权和邻接权等权利；</b>',
        '<b style="font-weight:bold">（2）与分享内容相关的词曲作者或表演者相关的署名权、肖像权、姓名权、照片/图片著作权、视听作品著作权等词曲作者、表演者的相关权利；</b>',
        '<b style="font-weight:bold">（3）与分享内容相关的专辑封面或专辑制作花絮、专辑图片等与专辑相关的权利；</b>',
        '<b style="font-weight:bold">（4）与分享内容相关的音乐文档、文字作品或介绍、宣传短片或其他相关音视频等相关内容的著作权等权利；</b>',
        '<b style="font-weight:bold">（5）为确保腾讯及其关联公司和/或其他第三方按照相关协议约定的方式予以使用分享上传内容的其他一切必要的权利。</b>',
        '<b style="font-weight:bold">你阅读并接受本协议，即代表着你将上述所有权利在全世界或相关地域范围内的，按照你入驻平台后与腾讯所签署的相关协议中约定的授权合作细节授权腾讯及其关联公司和/或其他第三方按照相关协议约定的方式予以行使。</b>',
      ]
    },
    {
      paragraphs: [
        '<b style="font-weight:bold">1.5 腾讯平台</b>',
        '指由腾讯及其关联公司所有/运营/管理的现有或将来可能出现的各种形式的产品，包括但不限于网站以及相应网站下属子页面（具体包括（i）网站以及相应网站下属子页面（具体包括但不限于www.qq.com、www.kugou.com、www.kuwo.cn、彩虹音乐频道等）；（ii）网页、电脑端、移动端等各种形式的客户端软件（具体包括但不限于QQ音乐、企鹅FM、轻听、微视、全民K歌、QQ、微信、QQ空间、音兔、MOO、腾讯视频、酷狗音乐、酷我音乐、彩虹音乐、酷我聚星、酷我K歌、酷我听书、2469、酷我BOOM、酷我电台、酷我视频、5sing、酷FM、酷狗直播、酷狗唱唱、酷狗KTV、酷狗铃声、酷狗直播伴侣、短酷、巴卟巴卟、1822、海兔故事、Viper HIFI等）；以及（iii）网页、客户端、移动APP等各种形式的游戏产品等。',
      ]
    },    
    {
      paragraphs: [
        '<b style="font-weight:bold">1.6 接收终端</b>',
        '指现有或将来可能出现的各种接收终端，包括但不限于电脑、平板电脑、手机、智能手表/手环/耳机、互联网/智能TV、车载电视、音响、机顶盒、MPEG4播放器、航空器电视、VR/可穿戴设备等。',
      ]
    },
    {
      paragraphs: [
        '<b style="font-weight:bold">1.7 传播网络</b>',
        '指现有或将来可能出现的各种信息数据传播网络，包括但不限于互联网、移动互联网、互联网电视（IPTV）等。',
      ]
    },
    {
      paragraphs: [
        '<b style="font-weight:bold">1.8分享形式</b>',
        '腾讯有权将全部分享内容和分享内容的全部权利以其自身及关联公司的名义基于传播网络/接收终端以在线收听服务、下载服务、网页/个人空间背景音乐定制、在线游戏背景音乐、MV在线播放业务、用户点歌、歌词翻译、互联网卡拉OK、音乐片段、互联网来电通话铃音或背景音、视频背景音、在线直播、在线表演、客户端背景音乐内置等形式和/或其他传播网络范围内的产品或业务形式以及未来因技术发展或业务创新而衍生的其他产品/业务形式提供给用户使用；以及腾讯与您所另行达成协议当中所约定的其他使用方式。',
      ]
    },
    {
      title: '二、协议的范围',
      paragraphs: [
        '<b style="font-weight:bold">2.1 协议适用主体范围</b>',
        '本协议是你与腾讯平台之间关于你在平台注册、登录、上传分享内容以及使用平台提供的其他相关服务所订立的协议。',
        '你理解并同意：',
        '<b style="font-weight:bold">（1）腾讯平台可以将基于本协议取得的权利义务一并转让给其关联公司，对于该转让行为腾讯或其关联公司可以站内信等其他形式通知你，转让行为实际发生后即对你产生约束力，转让行为发生前或后的所有的权利义务和责任均由新公司承担。</b>',
        '<b style="font-weight:bold">（2）你在本平台的分享内容，腾讯及其关联公司之任何一个或多个主体均可依据本协议的相关约定在任何地域无偿进行使用，除非你与腾讯及其关联公司之间另行有其他书面约定的。</b>',
        '2.2 协议关系及冲突条款',
        '本协议的内容，包括但不限于以下与本协议相关的协议、规则以及腾讯平台可能不断发布的关于本服务的相关协议、规则等内容，前述内容一经正式发布，即为本协议不可分割的组成部分，与其构成统一整体，你同样应当遵守：',
        '（1）《腾讯服务协议》（链接地址：http://www.qq.com/contract.shtml）；',
        '（2）《QQ号码规则》（链接地址：http://zc.qq.com/chs/agreement1_chs.html）；',
        '（3）《腾讯微信软件许可及服务协议》（链接地址：http://weixin.qq.com/agreement?lang=zh_CN）；',
        '（4）《隐私规则》（http://www.qq.com/privacy.htm）;',
        '若链接地址变更的，则以变更后的链接地址所对应的内容为准；其他链接地址变更的情形，均适用前述约定。本协议与上述内容存在冲突的，以本协议为准。',
      ]
    },
    {
      title: '三、关于平台',
      paragraphs: [
        '3.1 帐户注册',
        '（1）你应当通过登录腾讯平台的官方网站或其他官方指定途径，使用QQ号码、微信号、手机号或邮箱等注册平台帐户（下简称：帐号）以成为平台用户，帐户一经注册成功， 相应的QQ号码、微信号、手机号等不得变更，且该帐户不可转让、不可赠与、不可继承等。',
        '（2）你注册帐号时，应使用你拥有合法使用权的QQ号码或微信号等，并遵守《QQ号码规则》、《腾讯微信软件许可及服务协议》及相关协议、规则等的约束。同一用户（包括但不限于同一QQ号码、微信号、手机号、邮箱、身份证号码等）只能注册一次，不得重复注册。',
        '（3）你不得违反本协议约定将你的帐号用于其他目的。否则，腾讯平台有权随时单方限制、中止或终止向你提供本服务。',
        '（4）你注册帐号使用的QQ号码或微信号码，是你登录及使用本服务的凭证。你应当做好QQ号码、微信号码及其密码，以及进入和管理本服务中的各类产品与服务的口令、密码等的保密措施。',
        '（5）你保证：你注册帐号使用的QQ号码/微信号码是你拥有合法使用权的QQ号码/微信号码，你以注册时使用的QQ号码/微信号码在平台中进行的包括但不限于以下事项：注册帐号、提交相应资质材料、确认和同意相关协议和规则、选择具体服务类别以及可能进行的费用结算等事项，均是你的行为，对你均有约束力。同时，你承担以前述QQ号码/微信号码为标识进行的全部行为的法律责任。',
        '（6）若你发现有他人冒用或盗用你的帐号及密码、或任何其他未经你合法授权的情形时， 应立即以有效方式通知腾讯平台（包括但不限于提供你的身份信息和相关身份资料、相关事实情况及你的要求等）。腾讯平台收到你的有效请求并核实身份后，会根据不同情况采取相应措施。若你提供的信息不完全，导致腾讯平台无法核实你的身份或腾讯平台无法判断你的需求等， 而导致腾讯平台无法进行及时处理，给你带来的损失，你应自行承担。同时，腾讯平台对你的请求采取措施需要合理期限，对于你通知腾讯平台以及腾讯平台根据你的有效通知采取措施之前， 由于他人行为给你造成的损失，腾讯平台不承担任何责任。',
        '3.2 资质材料',
        '（1）你保证：你提供的主体资质材料、权利证明以及其他任何文件、信息等真实、准确、完整，并在信息发生变更后，会及时进行更新、通知腾讯平台。',
        '（2）你保证：你会依法及按照腾讯平台要求提交使用平台服务所必须的真实、准确的经过你签章确认的主体资质材料、权利证明以及你的身份信息等相关资料、信息。',
        '3.3 用户信息',
        '（1）你理解并同意：',
        '<b style="font-weight:bold">基于本服务的服务特性，腾讯平台在腾讯平台产品中向其他用户提供你的分享内容时，可以自主选择将你向平台提交的关于你本人或分享内容的相关信息对外进行展示或者展示给你同一帐号体系下（包括但不限于QQ号码等）的好友；</b>',
        '若腾讯平台收到任何关于你的分享内容侵犯他人权利的投诉时，腾讯平台有权基于投诉人的请求或根据腾讯平台的规则和自行判断，将你向平台提交的关于你或分享内容的相关信息披露给投诉人（无论投诉人的投诉是否最终依法成立，腾讯平台均有权将你或你分享内容的相关信息披露给投诉人）。',
        '（2）你在注册帐号或使用本服务的过程中，需要填写真实的身份信息，若你填写的信息不完整、不真实，则无法使用本服务或在使用过程中受到限制。',
        '（3）你注册后，对任何个人信息的修改都必须经过腾讯平台同意，且保证修改信息的真实性。',
        '<b style="font-weight:bold">3.4 平台规则</b>',
        '<b style="font-weight:bold">（1）你理解并同意：你将分享内容上传到平台后，腾讯平台有权根据平台的相关规则、规范，将你的分享内容展现、使用在任何腾讯平台产品中，并通过各种传播网络、接受终端、分享形式、地域等向其他广大用户传播、分享你的分享内容和/或按照腾讯与您所另行达成协议当中所约定的其他方式使用。</b>',
        '（2）你将你的分享内容上传到平台后，腾讯平台有权根据腾讯平台产品的实际情况，在协议约定的范围内，自主决定你的分享内容是否使用、使用的具体腾讯平台产品以及使用的时间、地域、使用方式等。对此，你表示完全的理解和同意。',
        '（3）腾讯平台在腾讯平台产品使用分享内容时，可以对外展示、使用你向平台提交的关于你或分享内容的相关信息，包括但不限于词作者、曲作者、表演者以及录音录像制作者等分享内容信息以及词作者、曲作者、表演者照片、专辑图片等与分享内容的相关内容。',
        '（4）你的分享内容在腾讯平台产品的播放量、下载量等传播效果，通常由你的分享内容的品质、用户的喜好等因素决定，因此，腾讯平台无法保证你的分享内容在腾讯平台产品中的任何传播效果。',
        '<b style="font-weight:bold">（5）你确认，在接受本协议当中的相关约定之后，你应及时在腾讯音乐开放平台当中另行签署其他书面合作协议并上传授权作品内容。如本协议与其他书面合作协议当中的约定不一致的，应优先适用其他书面合作协议当中的约定内容。</b>'
      ]
    },
    {
      title: '四、用户使用规范',
      paragraphs: [
        '<b style="font-weight:bold">4.1 用户禁止行为</b>',
        '你在使用本服务时不得利用本平台从事以下行为，包括但不限于：',
        '（1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、黄色、暴力、恐怖的内容；',
        '（2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；',
        '（3）虚构事实、隐瞒真相以误导、欺骗他人；',
        '（4）发表、传送、传播广告信息及垃圾信息；',
        '（5）从事其他违反法律法规、政策及公序良俗、社会公德等的行为。',
        '4.2 对自己行为负责',
        '你充分了解并同意，你必须为自己注册帐号下的一切行为负责，包括你所上传的任何内容以及由此产生的任何后果。',
        '4.3 违约处理',
        '如果腾讯平台发现或收到他人举报发现你有违反本协议约定的任何行为的，腾讯平台有权不经通知随时对相关分享内容进行删除、屏蔽，并采取包括但不限于暂停、终止你使用本平台帐号，暂停、终止你使用部分或全部本服务，追究法律责任等措施。',
        '4.4 侵权投诉及反通知',
        '在腾讯平台告知你或你自行得知你存在侵犯他人合法权益情形后，你应根据《腾讯音乐开放平台侵权投诉通知及反通知指引》（http://y.qq.com/cp/complaites.html）等腾讯平台的相应规定向相应腾讯平台提出反通知（你理解和同意：为了更好地维护你和投诉人的合法权益，在腾讯平台通过邮箱向你在平台登记的邮箱或以其他方式，将你上传的分享内容被投诉的信息告知你后，若你未在腾讯平台规定的3个工作日内向腾讯平台邮箱提交反通知的，则视为你对于投诉表示认可）但是，无论腾讯平台是否告知你、你是否提出反通知或反通知是否符合相关法规、腾讯平台要求等，均不影响腾讯平台进行自己的独立判断和随时采取相关措施。'
      ]
    },
    {
      title: '五、其他',
      paragraphs: [
        '5.1 你注册并使用本平台及本服务即视为你已阅读并同意受本协议的约束。腾讯平台有权在必要时修改本协议条款。你可以通过平台官网随时查阅相关协议条款。本协议条款变更后，如果你继续使用本平台及本服务，即视为你已接受修改后的协议。如果你不接受修改后的协议，应当注销本平台帐号并停止使用本服务；但并不意味着你与腾讯所另行达成的其他书面合作协议同样予以终止/解除。',
        '<b style="font-weight:bold">5.2 本协议签订地为中华人民共和国广东省深圳市南山区。</b>',
        '5.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。',
        '<b style="font-weight:bold">5.4 若你和腾讯平台之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，你同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</b>',
        '5.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。',
        '5.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。'
      ]
    },
  ]

  return (
    <div className="Agreement">
      <div className="m-clause">
        {title && <h1 className="u-clause-title">{title}</h1>}
        <div className="u-clause-content">
          {sections.map((ele, index) => <div
            className="u-clause-section"
            key={index}>
            {ele.title && <h2 v-if="ele.title">{ele.title}</h2>}
            {ele.paragraphs && <div>
              {
                ele.paragraphs.map((paragraph, paragraphIndex) => <p
                  key={paragraphIndex}>
                  <span dangerouslySetInnerHTML={{ __html: paragraph }}></span>
                </p>)
              }
            </div>}
          </div>)}

          {signature && <p
            className="u-clause-signature">
            {signature}
          </p>}
        </div>
        {/* <div className="u-bottom-bar">
          <div className="u-bottom-bar-inner">
            <p className="u-reading-tip">请阅读完酷狗音乐人认证协议，才能同意条款</b>
            <div className="u-confirm-btn-row">
              <Button text="我已阅读，并同意所有条款" />
            </div>
          </div>
        </div> */}
      </div>
    </div >
  )
}